
import React from 'react'
import Page from "../components/Page";
import { IonList, IonItem } from '@ionic/react';
import runes from '../data/runes';
import { ALPN_ENABLED } from 'constants';



class Runes extends React.Component {
  render() {
    return (
      <Page title="Runes" large >
        <div style={{padding: 16}}>
          <p>List of runes and where to find them with the highest drop chance.</p>
        </div>
        <IonList>
          <IonItem>
            <div style={{display: 'flex', fontSize: 13, fontWeight: 'bold'}}>
              <div style={{width: 50}}>Rune</div>
              <div style={{width: 50}}></div>
              <div style={{width: 50}}>Level</div>
              <div style={{flex: 1}}>Find best at</div>
            </div>
          </IonItem>
          {Object.keys(runes).map(key => 
            <IonItem key={key} routerLink={'/runes/'+key}>
              <div style={{display: 'flex'}}>
                <div style={{width: 50}}>
                  <img className="bright" src={'/assets/runes/'+key+'.png'} style={{width: 35, marginTop: 5}}/>
                </div>
                <div style={{width: 50, lineHeight: '50px'}}>{key}</div>
                <div style={{width: 50, lineHeight: '50px'}}>{runes[key].level}</div>
                <div style={{flex: 1, margin: 5, fontSize: 13}}>
                  {runes[key].boss}, {runes[key].difficulty} <br /> 
                  <span style={{lineHeight: '23px'}}>drop chance <b>{runes[key].dropChance}</b></span>
                </div>
              </div>
            </IonItem>
          )}
        </IonList>
      </Page>
    )
  }
}

export default Runes